export function initSearchform() {
    const openSearchformBtn = document.getElementById('open-searchform');
    const searchform = document.getElementById('sg-searchform');

    if (openSearchformBtn != null && openSearchformBtn != 'undefined') {
        openSearchformBtn.addEventListener('click', function (event) {
            openSearchformBtn.classList.toggle('open');
            searchform.classList.toggle('open');
        });
    
        openSearchformBtn.addEventListener('keydown', function(event) {
            if (event.key === ' ' || event.code === 'Space') {  // Überprüfe, ob die Leertaste gedrückt wurde
                event.preventDefault(); // Verhindert das Standardverhalten der Leertaste (z.B. Scrollen)
                openSearchformBtn.classList.toggle('open');
                searchform.classList.toggle('open');

                if (searchform.classList.contains('open')) {
                    const searchInput = document.getElementById('search-input');
                    searchInput.setAttribute('tabindex', '0');
                    const searchSubmit = document.querySelector('.search-submit');
                    searchSubmit.setAttribute('tabindex', '0');
                    searchInput.focus();
                } else {
                    const searchInput = document.getElementById('search-input');
                    searchInput.setAttribute('tabindex', '-1');
                    const searchSubmit = document.querySelector('.search-submit');
                    searchSubmit.setAttribute('tabindex', '-1');
                    openSearchformBtn.focus();
                }
            }
        });
    } 

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.code === 'Escape') {
            if (searchform.classList.contains('open')) {
                openSearchformBtn.classList.remove('open');
                searchform.classList.remove('open');
                const searchInput = document.getElementById('search-input');
                searchInput.setAttribute('tabindex', '-1');
                const searchSubmit = document.querySelector('.search-submit');
                searchSubmit.setAttribute('tabindex', '-1');
                openSearchformBtn.focus();
            }
        }
    }); 
}
